import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isDesktop, isNotEmpty } from '../../../lib/ep';

import ActionLink from '../../builder/ActionLink';

const ParticipateAgainButton = (props) => {
	const promotion = props?.promotion ?? false;
	if(promotion === false) return null;

	const is_builder = props?.is_builder ?? false;

	const is_multiparticipation = promotion?.multi_participation ?? false;
	if(!is_multiparticipation) return null;
	
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	const user = props?.user ?? false;

	const one_prize_per_promotion = promotion?.one_prize_per_promotion ?? false;

	const remaining_participations = props?.remaining_participations ?? false;

	const has_already_won = props?.has_already_won ?? false;
	let total_tries = parseInt(remaining_participations?.in_period ?? (promotion?.max_entries_per_user ?? 0));
	let used_tries = remaining_participations?.used ?? 0;
	let can_participate = true;
	if(used_tries >= total_tries) can_participate = false;
	if(has_already_won && one_prize_per_promotion) can_participate = false;
	let display_participations = (can_participate && total_tries <= 10) ? true : false;

	let label = props?.children ?? (promotion?.custom_labels?.enter_again_button ?? i18n("Enter again"));

	if(display_participations && remaining_participations !== false) {
		label += ` (${props.intl.formatMessage({ id:"{actual} out of {total}" }, { actual:used_tries, total:total_tries })})`;
	}

	if(!can_participate && remaining_participations === false) {
		return null;
	}

	if(!can_participate && remaining_participations !== false) {
		// Don't display this button if we don't have possibility to access again at the moment
		// > https://app.asana.com/0/1201935325412224/1202254335545960/f
		return null;
	}

	const target = (!isDesktop()) ? '_top' : null;
	const in_widget = props?.in_widget ?? false;
	let link = props?.link ?? `/promotions/participate/${promotion.id}`;
	//let link = props?.link ?? `/promotions/participate/${promotion.id}${(isNotEmpty(user, 'stage')) ? `/${user.stage}` : ''}`;
	if(in_widget) link += '/?fromwidget=1';

	const icon = props?.icon ?? 'knk-reload';

	return (
		<ActionLink
			icon={icon}
			_href={(!is_builder) ? link : null}
			_target={target}
			autotranslate={false}
			_class={{ other:'enter_again_btn' }}
		>{label}</ActionLink>
	)
};

export default injectIntl(ParticipateAgainButton);